import React, { useState } from 'react';
import { Box, Container, Divider, Grid2 as Grid, IconButton, Paper, Typography } from '@mui/material';
import AppointmentDetailsProvider, { useAppointmentDetailsContext } from './contexts/appointmentdetails.context';
import AppointmentChat from './components/appointmentchat';
import { useSelector } from 'react-redux';
import { USER_ROLES } from '../../../utils/constants';
import AppointmentDetailsTab from './components/appointmentdetailstab';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';
import AppointmentReports from './components/appointmentreports';
import AppointmentPrescriptions from './components/appointmentprescriptions';
// import AppointmentVideoCall from './components/apptvidcall.component';
import './appointmentdetails.css';

const TABS = {
    DETAILS: {
        id: 'details',
        name: 'Details',
    },
    TEST_REPORTS: {
        id: 'test_reports',
        name: 'Test Reports',
    },
    PRESCRIPTIONS: {
        id: 'prescriptions',
        name: 'Prescriptions',
    },
    CHAT: {
        id: 'chat',
        name: 'Chat',
    },
    // VCALL: {
    //     id: 'vcall',
    //     name: 'Video Call',
    // },
};

const AppointmentDetailsContent = () => {
    const { appointmentDetails } = useAppointmentDetailsContext();
    const [activeTab, setActiveTab] = useState(TABS.DETAILS.id);

    const handleTabSelection = (tabID) => () => setActiveTab(tabID);

    const tabsHeaderUI = Object.values(TABS).map((tab) => {
        const tabClass = `doc-category ${tab.id === activeTab && 'active'}`;
        return (
            <Grid size={{ xs: 12, sm: 3 }} key={tab.id}>
                <Box
                    className={tabClass}
                    onClick={handleTabSelection(tab.id)}
                >
                    <Typography variant='h6'>
                        {tab.name}
                    </Typography>
                </Box>
            </Grid>
        );
    });

    const tabsContentUI = () => {
        switch (activeTab) {
            case TABS.CHAT.id:
                return <AppointmentChat />;
            case TABS.TEST_REPORTS.id:
                return <AppointmentReports />;
            case TABS.PRESCRIPTIONS.id:
                return <AppointmentPrescriptions />;
            // case TABS.VCALL.id:
            //     return <AppointmentVideoCall />;
            default:
                return <AppointmentDetailsTab />;
        }
    };

    if (!appointmentDetails) return;

    return (
        <>
            <Grid container spacing={2} my={1}>
                {tabsHeaderUI}
            </Grid>
            <Box>
                {tabsContentUI()}
            </Box>
        </>
    );
};

const AppointmentDetailsPage = () => {
    const userInfo = useSelector(state => state.auth.user);
    const navigate = useNavigate();

    const handleBack = () => {
        if (userInfo && userInfo.role && userInfo.role === USER_ROLES.DOCTOR) {
            navigate('/admin/appointments');
            return;
        }

        // for patient
        navigate('/myappointments');
    };

    const detailsPageUI = (
        <Container component='main' maxWidth='lg' sx={{ mt: 3, mb: 3 }}>
            <Paper elevation={3} className='mydata-grid'>
                <Box style={{display: 'flex', gap: '.5rem'}}>
                    <IconButton onClick={handleBack}><ArrowBackIcon /></IconButton>
                    <Typography variant='h5' className='heading' sx={{ textAlign: 'left' }}>
                        Appointment Details
                    </Typography>
                </Box>
                <Divider />
                <AppointmentDetailsProvider>
                    <AppointmentDetailsContent />
                </AppointmentDetailsProvider>
            </Paper>
        </Container>
    );

    const roleBasedDetailsPage = () => {
        if (!userInfo) return;
        if (userInfo.role && userInfo.role === USER_ROLES.DOCTOR) {
            return (
                <div className='admin-area-2'>{detailsPageUI}</div>
            );
        }

        // for patient
        return detailsPageUI;
    };

    return (
        <>{roleBasedDetailsPage()}</>
    );
};

export default AppointmentDetailsPage;